import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

import { DevPortalTestingAccount } from '../../../interfaces/user';
import { getTestingAccount } from '../../../services/DevPortalService';
import Button from '../../Button/Button';

import HornImg from '../../../assets/horn.svg';
import ChartImg from '../../../assets/chart.svg';
import ActiveDot from '../../../assets/icons/ActiveDot';
import NormalDot from '../../../assets/icons/NormalDot';

import { emptyDevPortalTestingAccount } from '../../../constants/devPortalTestingAccount';
import TestingAccountDetails from '../../TestAccountDetails/TestAccountDetails';
import useDeveloperAccountModalStyles from './styles';

const PageOne: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <>
    <Typography variant="subtitle1">Developer Account Rules</Typography>
    <img className="ds-modal-image" src={HornImg} alt="Alert" />

    <Typography>
      <b>As detailed in the Dataswift Developers End User Licence Agreement,</b> Dataswift
      Developers Portal provides the User with a development and testing environment. The User
      agrees to use the Dataswift Developers Portal as a development and testing environment only.
      Dataswift reserves the right to monitor User activity and may remove the User and all User
      applications from the Developer Portal if the User is in breach of this obligation.
    </Typography>

    <Button text="Okay" className="ds-app-button" onClick={onClick} />
  </>
);

const PageTwo: React.FC<{ user: DevPortalTestingAccount; onClick: () => void }> = ({
  user,
  onClick,
}) => (
  <>
    <Typography variant="subtitle1">Testing Account</Typography>
    <img className="ds-modal-image" src={ChartImg} alt="Notes" />

    <Typography>
      Here are the details of the test PDA that has been created for you, this can be used to test
      your applications. If you need to find these details again, they can found under the
      &apos;Test Account&apos; option in the navigation bar.
    </Typography>

    <div>
      <TestingAccountDetails user={user} />
    </div>

    <Button text="I Understand" className="ds-app-button" onClick={onClick} />
  </>
);

const DeveloperAccountModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [currentPage, setCurrentPage] = useState<1 | 2>(1);
  const [user, setUser] = useState<DevPortalTestingAccount>(emptyDevPortalTestingAccount);
  const classes = useDeveloperAccountModalStyles();
  const theme = useTheme();

  useEffect(() => {
    const getTesting = async () => {
      try {
        const res = await getTestingAccount();
        if (res?.parsedBody && res.parsedBody.length > 0) {
          setUser(res.parsedBody[0]);
        }
      } catch (e) {
        console.log(e);
      }
    };

    getTesting();
  }, []);

  const onOkayClick = () => setCurrentPage(2);
  const onIUnderstandClick = () => {
    window.localStorage.removeItem('new_signup');
    onClose();
  };

  return (
    <div className={classes.wrapper}>
      {currentPage === 1 ? (
        <PageOne onClick={onOkayClick} />
      ) : (
        <PageTwo user={user} onClick={onIUnderstandClick} />
      )}

      <div className={classes.progressRow}>
        {currentPage === 1 ? (
          <ActiveDot className="current" fill={theme.palette.text.primary} />
        ) : (
          <NormalDot fill={theme.palette.grey[600]} />
        )}
        {currentPage === 2 ? (
          <ActiveDot className="current" fill={theme.palette.text.primary} />
        ) : (
          <NormalDot fill={theme.palette.grey[600]} />
        )}
      </div>
    </div>
  );
};

export default DeveloperAccountModal;
